module.exports = __webpack_public_path__ + "static/media/angela-win.2c42615e.jpg";